module.exports = __webpack_public_path__ + "site/img/16.2105c4c4.jpg";